import { render, staticRenderFns } from "./SocialValue.vue?vue&type=template&id=974ae0bc&scoped=true"
import script from "./SocialValue.vue?vue&type=script&lang=js"
export * from "./SocialValue.vue?vue&type=script&lang=js"
import style0 from "./SocialValue.vue?vue&type=style&index=0&id=974ae0bc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "974ae0bc",
  null
  
)

export default component.exports